import classes from "./BoldTitle.module.scss";
import {Fragment} from "react-dom"

function BoldTitle(props) {
  return  <> <h3 className={classes.BoldTitle + " " + props.customClass}>{props.text}</h3> </>
}


export default BoldTitle;